import { useRef } from "react";

import { BTIndexedDB } from "./BTIndexedDB";

export function useIndexedDB<StoreType, KeyType>(storeName: string, keyPath: string | string[]) {
    const dbRef = useRef<BTIndexedDB<StoreType, KeyType>>();

    if (!dbRef.current) {
        dbRef.current = new BTIndexedDB<StoreType, KeyType>(storeName, keyPath);
    }

    const getValue = async (key: KeyType): Promise<StoreType | null> => {
        if (!dbRef.current) {
            return null;
        }
        return await dbRef.current.get(key);
    };

    const setValue = async (key: KeyType, value: StoreType): Promise<void> => {
        await dbRef.current!.set(key, value);
    };

    const removeValue = async (key: KeyType): Promise<void> => {
        await dbRef.current!.remove(key);
    };

    const getAll = async (): Promise<StoreType[]> => {
        return await dbRef.current!.getAll();
    };

    const clear = async (): Promise<void> => {
        await dbRef.current!.clear();
    };

    return {
        getValue,
        setValue,
        removeValue,
        getAll,
        clear,
    };
}
